import React from 'react';
import styles from './Legend.css';
import { useAppSelector } from '../../../utils';

export type Legend = () => {
  legendItem: React.ReactNode;
};

export const Legend = ({ legendItem }) => {
  const isSplitViewEnabled = useAppSelector(state => state.layers.isSplitViewEnabled);

  const className = `${styles.legend} ${isSplitViewEnabled ? styles.legendSplit : ''}`;

  return <div className={className} data-test-id="legend-container">{legendItem}</div>;
};
